export function getPokerGoEvents(jsonPath) {
  return fetch(jsonPath, {
    method: 'GET',
  })
    .then((res) => {
      if (!res.ok) {
        throw Error('Response error');
      }
      return res.json();
    })
    .then((res) => res.data);
}